import { render } from "./EntregasFreteView.vue?vue&type=template&id=db59beee&scoped=true"
import script from "./EntregasFreteView.vue?vue&type=script&lang=js"
export * from "./EntregasFreteView.vue?vue&type=script&lang=js"

import "./EntregasFreteView.vue?vue&type=style&index=0&id=db59beee&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Garantidoras\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db59beee"]])

export default __exports__